import { observer } from 'mobx-react';
import { FC } from 'react';

import { EditorProps, getEditableCell, TableCellProps } from '@servicetitan/table';
import { Switch } from '@servicetitan/anvil2';

import { PhoneData } from '../types/phone-data';

const Viewer: FC<TableCellProps<PhoneData>> = ({ dataItem, field, tableState }) => {
    if (!tableState || !field) {
        return <td>-</td>;
    }

    return <td>{dataItem[field] ? 'Yes' : 'No'}</td>;
};

const Editor = observer(({ tableState, fieldState }: EditorProps<boolean>) => {
    if (!tableState?.getFormState) {
        return <td />;
    }

    const { value, onChange } = fieldState;

    return (
        <td>
            <Switch
                label={value ? 'Yes' : 'No'}
                checked={value}
                onChange={(_, state) => {
                    onChange(state.checked);
                }}
            />
        </td>
    );
});

export const SmsCell = getEditableCell({
    viewer: Viewer,
    editor: Editor,
});
